<template lang="pug">
  include /mixins
  +b.user-review
    validation-observer(
      ref="validator",
      v-slot="{ valid }",
      tag="form",
    )
      ui-loader(v-if='isLoad')
      +b.close-popup.mdi.mdi-close.A(
        href='',
        v-if='!info.inline'
        @click.prevent='$emit("close")'
      )
      +b.review-top
        +e.title {{ _('Оставьте свой отзыв!') }}
        +e.text {{ _('нам важно ваше мнение') }}
      +e.body
        +b.g-row
          +b.g-cell.g-cols--12
            +b.ds-caption.--size_2xs.--appearance_center.P {{ placeholder }}
            +b.g-row--align_center.--justify_between.--justify_center-xl.tt-space_mt--4
              cell(
                cols='12'
              )
                d-control-textarea.is-textarea(
                  :input-label='labels.comment'
                  :rules="'required|min:5'",
                  rows='4'
                  v-model='form.comment',
                  name='comment',
                  ref='comment'
                  error-classes='error-label--top'
                )
              cell(
                cols='12'
              )
                +b.tt-space_mt--4.D-CONTROL-INPUT(
                  :rules="'required|max:30'",
                  :input-label='labels.name'
                  v-model='form.name'
                  id='name',
                  name='name',

                )
              cell(
                cols='12'
              )
                +b.tt-space_mt--4.PHONE-INPUT(
                  :rules="'required|phone'",
                  :input-label='labels.phone'
                  v-model='form.phone',
                  ref='phone'
                  name='phone'
                )
              cell(
                cols='12'
                align='center'
              )
                +b.tt-button--grey.--mini.BUTTON.tt-space_mt--4.tt-space_mb--4(
                  type='submit'
                  :disabled='isLoad',
                  @click.prevent='prepareData(valid)'
                )
                  +e.title.P {{ _('Отправить отзыв ') }}
</template>

<script>

import {
  ReviewCreate,
} from '@api/review.service'

import {
  AnswerMessage,
} from '@utils/submit'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

export default {
  name: 'UserReview',
  mixins: [FormMixin],
  props: {
    info: {

    },
    promise: {},
  },
  data() {
    return {
      placeholder: this._('Поделитесь впечатлением о специалисте. Будьте объективны, ваш отзыв поможет другим пользователям выбрать подходящего специалиста'),
      labels: {
        name: this._('Ваше ім‘я '),
        phone: this._('Ваш номер телефону'),
        comment: this._('Ваше враження'),
      },
      form: {
        comment: this.info.reply_name ? `${this.info.reply_name}, ` : '',
        name: '',
        phone: '',
        element: {
          type: this.info.product_type,
          id: this.info.product_id,
        },
        parent: this.info.id,
        reply: this.info.reply,
      },
      non_field_errors: '',
      isLoad: false,
    }
  },
  methods: {

    async prepareData(valid) {
      this.$refs.validator.validate()
      if (!valid) return

      this.submit(valid, this.form)
    },
    send(data) {
      return ReviewCreate.execute({}, data)
        .then(({ data: res }) => {
          this.$emit('close')
          AnswerMessage(res, this)
          this.form.name = null
          this.form.phone = null
          this.form.comment = null
          this.$refs.validator.$el.reset()
          this.$refs.validator.reset()
        })
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
  },

}
</script>
